import types from 'store/types/auth';
import { API_PATHS, AUTHORIZED_REDIRECT_URL } from '../../helpers/endpoints';
import {
  CLIENT_ID_ROUTI,
  GRANT_TYPE_AUTH_CODE,
  GRANT_TYPE_REFRESH_TOKEN,
  HTTP_METHODS,
  SCOPE_COOKIE,
} from '../../helpers/constants';
import Requester from '../../helpers/requester';
import axios from 'axios';

export default {
  getUser: () => async (dispatch) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: API_PATHS.AUTH_INTROSPECT,
        data: new URLSearchParams({
          client_id: CLIENT_ID_ROUTI,
        }),
      });
      dispatch({ type: types.AUTH_SET, key: 'userIntrospect', data: response });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getAccount: (userName) => async (dispatch, getState) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.USERS_SEARCH}?filter=username==${userName} and active==true&page=0`,
      });
      dispatch({
        type: types.AUTH_SET,
        key: 'user',
        data: response?._embedded?.userResponseDtoList[0],
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  logout: async () => {
    return Requester.submit({
      method: HTTP_METHODS.POST,
      url: API_PATHS.AUTH_LOGOUT,
      data: new URLSearchParams({
        client_id: CLIENT_ID_ROUTI,
      }),
    }).then(() => {
      window.location.replace('/login');
    });
  },

  getAccessToken: async (
    code,
    grant_type = GRANT_TYPE_AUTH_CODE,
    redirect_uri,
  ) => {
    const postData = new URLSearchParams(
      grant_type === GRANT_TYPE_REFRESH_TOKEN
        ? {
            grant_type,
            client_id: CLIENT_ID_ROUTI,
          }
        : {
            code,
            redirect_uri: AUTHORIZED_REDIRECT_URL.replace(
              '[origin]',
              redirect_uri,
            ),
            client_id: CLIENT_ID_ROUTI,
            grant_type,
            scope: SCOPE_COOKIE,
          },
    );

    const axiosInstance = axios.create({
      withCredentials: true,
    });

    return await axiosInstance.post(API_PATHS.AUTH_TOKEN, postData);
  },

  updatePassword: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PATCH,
        url: `${API_PATHS.UPDATE_PASSWORD}`,
        data
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
};
